import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiCoreService } from '@qtek/core/api-core';
import { LocalStorageActions } from '@qtek/core/local-storage-management';
import { AuthUserStore } from '@qtek/libs/auth-user';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { ThemeManagementActions } from './theme-management.actions';

@Injectable()
export class ThemeManagementEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly apiCoreService: ApiCoreService = inject(ApiCoreService);
  private readonly authUserStore = inject(AuthUserStore);

  setTheme$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ThemeManagementActions.setTheme),
      switchMap(({ theme }) =>
        this.apiCoreService.postUserData({ theme }).pipe(
          map(() => ThemeManagementActions.setThemeSuccess({ theme })),
          catchError(() => of(ThemeManagementActions.setThemeFailure()))
        )
      )
    )
  );

  setThemeSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ThemeManagementActions.setThemeSuccess),
        tap(() => this.authUserStore.getUser())
      ),
    { dispatch: false }
  );

  setThemeSuccessSaveToLocalStorage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ThemeManagementActions.setThemeSuccess),
      map(({ theme }) =>
        LocalStorageActions.saveToLocalStorageByKey({
          key: 'uiTheme',
          value: theme,
        })
      )
    )
  );
}
